import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import TvProgramService from "./TvProgramService";


export const getTvPrograms = createAsyncThunk("TvProgram/get-TvPrograms", async (thunkAPI) => {
  try {
    return await TvProgramService.getTvPrograms();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createTvPrograms = createAsyncThunk(
  "TvProgram/create-TvPrograms",
  async (TvProgramData, thunkAPI) => {
    try {
      return await TvProgramService.createTvPrograms(TvProgramData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getTvProgram = createAsyncThunk(
  "TvProgram/get-TvProgram",
  async (id, thunkAPI) => {
    try {
      return await TvProgramService.getTvProgram(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateTvProgram = createAsyncThunk(
  "TvProgram/update-TvProgram",
  async (brand, thunkAPI) => {
    try {
      return await TvProgramService.updateTvProgram(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteATvProgram = createAsyncThunk(
  "TvProgram/delete-TvProgram",
  async (id, thunkAPI) => {
    try {
      return await TvProgramService.deleteTvProgram(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  TvPrograms: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const TvProgramSlice = createSlice({
  name: "TvProgram",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTvPrograms.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTvPrograms.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.TvPrograms = action.payload.data;
      })
      .addCase(getTvPrograms.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createTvPrograms.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createTvPrograms.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdTvProgram = action.payload;
      })
      .addCase(createTvPrograms.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(getTvProgram.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTvProgram.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.TvProgramName = action.payload.data.name;
        state.TvProgramtime= action.payload.data.time; 
      })
      .addCase(getTvProgram.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateTvProgram.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateTvProgram.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedTvProgram = action.payload;
      })
      .addCase(updateTvProgram.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteATvProgram.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteATvProgram.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedTvProgram = action.payload;
      })
      .addCase(deleteATvProgram.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default TvProgramSlice.reducer;
